import { PersonOutline, QuestionMark } from '@mui/icons-material'
import { IconButton, Stack } from '@mui/material'
import { RouterLink } from '@/components/router-link'
import { OCTA_DESK_PHONE } from '@/constants/phones'
import { isViewAs } from '@/helpers'
import { routes } from '@/router'

export function ProductHeaderActions() {
  return (
    <Stack direction="row" spacing={1}>
      {!isViewAs() && (
        <RouterLink to={routes.account}>
          <IconButton color="primary">
            <PersonOutline />
          </IconButton>
        </RouterLink>
      )}
      <IconButton
        color="primary"
        title="Ajuda"
        component="a"
        href={`https://api.whatsapp.com/send?phone=${OCTA_DESK_PHONE}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <QuestionMark />
      </IconButton>
    </Stack>
  )
}
